import { lowerCase, isEmpty } from 'lodash-es'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import orderAddressOptions from '../api/orderAddressOptions'
import { phoneNumberSanitizer } from '../../main/js/es6/utilities/sanitizers'
import api from '../api'

export default {
  data () {
    return {
      currencySign: '€',
      password: '',
      passwordVerify: '',
      redeemPoints: false,
      sameShipping: true,
      isCourierAddress: '1',
      termsChecked: false,
      newsletterRegister: false,
      moosendnewsletterRegister: false,
      apifonNewsletterRegister: false,
      mailchimpNewsletterRegister: false,
      apcoInstallments: '0',
      piraeusInstallments: '0',
      eurobankInstallments: '0',
      minCartTotalAmountForPaidAtStore: '0',
      localErrors: {},
      klarnaPaymentSession: {},
      klarnaAuthorization: {}
    }
  },
  mounted () {
    this.$store.dispatch('setAllTransporterSmartPoints', this.smartPointsData)
  },
  watch: {
    serverUseAddress (val) {
      switch (val) {
        case orderAddressOptions.shipping:
          this.sameShipping = false
          this.isCourierAddress = '1'
          break
        case orderAddressOptions.billing:
          this.sameShipping = true
          this.isCourierAddress = '1'
          break
        case orderAddressOptions.store:
          this.isCourierAddress = '0'
      }
    },
    'previewOrderData.transporterId' (val) {
      this.$store.commit('setSelectedTransporterId', val)
    },
    isCourierAddress (val) {
      if ('0' === val) {
        this.smartPointUncheck()
      }
    },
    getSmartPointIsSelected (val) {
      if (val === true) {
        this.sameShipping = true
      }
    },
    displayGiftError (val) {
      if (val === true) {
        this.$nextTick(() => {
          this.$refs.AdvGiftChoiceModalV2.$refs.AdvGiftChoiceGenericModal.openModal()
        })
      }
    },
    'customerData.country': {
      async handler (value) {
        await this.handleCartData(
          this.previewOrderData.invoiceType === 'invoice',
          this.useAddress,
          this.useAddress === '1' ? value : null,
          this.useAddress === '0' ? this.customerData.sendto_country : null
        )
      }
    },
    'customerData.sendto_country': {
      async handler (value) {
        await this.handleCartData(
          this.previewOrderData.invoiceType === 'invoice',
          this.useAddress,
          this.useAddress === '1' ? this.customerData.country : null,
          this.useAddress === '0' ? value : null
        )
      }
    },
    'previewOrderData.invoiceType': {
      async handler (value) {
        await this.handleCartData(
          value === 'invoice',
          this.useAddress,
          this.useAddress === '1' ? this.customerData.country : null,
          this.useAddress === '0' ? this.customerData.sendto_country : null
        )
      }
    },
    useAddress: {
      async handler (value) {
        await this.handleCartData(
          this.previewOrderData.invoiceType === 'invoice',
          value,
          value === '1' ? this.customerData.country : null,
          value === '0' ? this.customerData.sendto_country : null
        )
      }
    },
    orderTotal() {
      if (this.previewOrderData.payWay === 'klarna_payments') {
        if (this.klarnaPaymentSessionSessionId === '') {
          this.openPaymentSession()
        } else {
          this.updatePaymentSession()
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'previewOrderData',
      'cartEmpty',
      'cartProductsCount',
      'cartProductsTotal',
      'getTransporters',
      'giftUserSelectionStatus',
      'getSelectedTransporterId',
      'getSmartPointIsSelected',
      'getSelectedTransporterClassName',
      'getSelectedTransporterSmartPointEnable',
      'getSelectedSmartPoint',
      'getSelectedTransporterDeliveryOptionType',
      'getIsSmartPointOnlyTransporter',
      'getSelectedTransporterSmartPointsApiError',
      'getVatError',
      'getSelectedCurrency',
      'getSelectedTransporterObject',
      'cartProductWeightTotal',
      'getSelectedTransporterExternalRate',
      'isCustomerLoggedIn',
      'config',
      'getGiftPackaging',
      'klarnaPaymentAuthorizationGetter',
      'klarnaPaymentSessionGetter'
    ]),
    passwordRetype () {
      return this.customerData.password === this.customerData.passwordVerify ? '' : this.t('password-retype-error')
    },
    showPointsBlocks () {
      if (!this.previewOrderData || !this.cartProductsTotal) {
        return false
      }

      if (!this.previewOrderData.loyalty.pointSystemIsEnabled) {
        return false
      }

      return this.previewOrderData.loyalty.customerTotalPoints &&
        this.previewOrderData.loyalty.customerCash > 0 &&
        this.previewOrderData.loyalty.customerCash < this.cartProductsTotal
    },
    validPayWays () {
      let filtered = this.previewOrderData.payWays

      // moved checks for country to separate function
      if (this.deliveryAvailability) {
        this.previewOrderData.payWay = filtered[0].key
        filtered = _.filter(filtered, function (element) {
          return element.key !== 'delivery'
        })
      }
      return filtered
    },
    // check for not selected country or country = "GR" to add or remove payway = "delivery".
    deliveryAvailability () {
      return (this.countryCheckForDelivery || this.sendToCountryCheckForDelivery)
    },
    countryCheckForDelivery () {
      return (this.customerData.country !== 'GR' && this.customerData.country !== '' && this.sameShipping)
    },
    sendToCountryCheckForDelivery () {
      return (this.customerData.sendto_country !== 'GR' && this.customerData.sendto_country !== '' && !this.sameShipping)
    },
    availableCounties () {
      if (this.customerData.country === '') {
        return {}
      }
      return this.previewOrderData.countryAndCountyData.county[this.customerData.country] || {}
    },
    availableCountiesShipping () {
      if (this.customerData.sendto_country === '') {
        return {}
      }
      return this.previewOrderData.countryAndCountyData.county[this.customerData.sendto_country] || {}
    },
    activeStores () {
      return this.previewOrderData.activeStores
    },
    orderCountry () {
      if (!this.isCourierAddress) {
        return ''
      }
      return this.sameShipping ? this.customerData.country : this.customerData.sendto_country
    },
    orderCounty () {
      if (!this.isCourierAddress) {
        return ''
      }
      return this.sameShipping ? this.customerData.county : this.customerData.sendto_county
    },
    orderPostal () {
      if (!this.isCourierAddress) {
        return ''
      }
      if (this.sameShipping) {
        return this.customerData.postal === null ? '' : this.customerData.postal.replace(/\s/g, '')
      }
      return this.customerData.sendto_postal === null ? '' : this.customerData.sendto_postal.replace(/\s/g, '')
    },
    orderCity () {
      if (!this.isCourierAddress) {
        return ''
      }
      return this.sameShipping ? this.customerData.city : this.customerData.sendto_city
    },
    orderAddress () {
      if (!this.isCourierAddress) {
        return ''
      }
      return this.sameShipping ? this.customerData.address : this.customerData.sendto_address
    },
    transporter () {
      return this.getTransporters?.find(item => item.transporter_id === this.previewOrderData.transporterId)
    },
    transportationCost () {
      if (!this.transporter || this.previewOrderData.payWay === 'paid_at_store' || this.useAddress === orderAddressOptions.store) {
        return 0
      }

      if (this.transporter?.eshop_calculated_cost === "0") {
        return this.getSelectedTransporterExternalRate?.price || 0
      }

      return this.transporter.transportationCost
    },
    overweightCost () {
      if (!this.transporter || this.previewOrderData.payWay === 'paid_at_store' || this.useAddress === orderAddressOptions.store) {
        return 0
      }
      return this.transporter.overweightCost
    },
    deliveryCost () {
      if (!this.transporter || this.previewOrderData.payWay !== 'delivery') {
        return 0
      }
      return this.transporter.deliveryCost
    },
    deliveryCostVerbal () {
      if (!this.transporter) {
        return 0
      }
      return this.transporter.deliveryCost
    },
    couponDiscount () {
      return parseFloat(this.previewOrderData.couponDiscount) || 0
    },
    giftPackagingCost () {
      if (!this.config?.giftPackaging?.enable) {
        return 0
      }
      return this.getGiftPackaging ? this.config?.giftPackaging?.cost || 0 : 0
    },
    orderTotal () {
      const customerPointsCash = this.redeemPoints ? this.previewOrderData.loyalty.customerCash : 0
      return this.cartProductsTotal - this.couponDiscount + this.deliveryCost + this.transportationCost - customerPointsCash + this.giftPackagingCost
    },
    customerPointsRedeemValue () {
      if (!this.redeemPoints) {
        return 0
      }
      return this.previewOrderData ? this.previewOrderData.loyalty.customerCash.toFixed(2) : 0
    },
    useAddress () {
      if (this.isCourierAddress === '0') {
        return orderAddressOptions.store
      }

      return this.sameShipping ? orderAddressOptions.billing : orderAddressOptions.shipping
    },
    serverUseAddress () {
      return this.previewOrderData.useAddress
    },
    errors () {
      return this.previewOrderData.errors
    },
    customerData () {
      return this.previewOrderData.customerData
    },
    isCartTotalAbovePaidAtStoreMinCartTotalLimit () {
      return this.cartProductsTotal > this.previewOrderData.minCartTotalAmountForPaidAtStore
    },
    smartPointsData () {
      return this.previewOrderData.smartPointStationData
    },
    shouldDisplaySmartPoints () {
      return this.getSelectedTransporterSmartPointEnable
    },
    smartPointValidationError () {
      const logic = (
        this.getSelectedTransporterSmartPointEnable &&
        this.getIsSmartPointOnlyTransporter &&
        this.getSelectedSmartPoint === null &&
        '1' === this.isCourierAddress
      ) || (
        this.getSmartPointIsSelected &&
        !this.getIsSmartPointOnlyTransporter &&
        this.getSelectedSmartPoint === null &&
        '1' === this.isCourierAddress
      )
      return logic
    },
    displayLocalErrors () {
      return !isEmpty(this.localErrors)
    },
    displayGiftError () {
      return !isEmpty(this.localErrors?.gifts)
    },
    passwordRequired () {
      if (this.isCustomerLoggedIn) {
        return false
      }
      return this.customerData.is_guest !== '1'
    },
    klarnaAuthorizationToken () {
      return this.klarnaPaymentAuthorizationGetter
    },
    klarnaPaymentSessionSessionId() {
      if (!this.klarnaPaymentSessionGetter) {
        return ''
      }

      return this.klarnaPaymentSessionGetter?.session_id
    },
    isKlarnaPaymentsActive() {
      let klarna = this.previewOrderData.payWays.find(o => o.key === 'klarna_payments')
      return klarna !== undefined
    }
  },
  methods: {
    ...mapActions([
      'setPreviewOrderTransporterId',
      'validateVat',
      'getExternalTransporterCost',
      'setLiveProducts',
      'setCartProducts',
      'setCartLiveData',
      'setGiftContents',
      'openPaymentSessionAction'
    ]),
    validateForm (e) {
      this.localErrors = {}
      const selectedTransporter = this.getSelectedTransporterObject

      if (this.isCourierAddress === '0' && this.activeStores.length > 1 && !this.previewOrderData.storeId) {
        this.localErrors.store = this.t('checkout.validation.error.store')
      }

      if (this.isCourierAddress === '1' && !this.previewOrderData.transporterId) {
        this.localErrors.transporter = this.t('checkout.validation.error.transporter')
      }

      if (this.isCourierAddress === '1' && selectedTransporter?.eshop_calculated_cost === "0" && !this.getSelectedTransporterExternalRate) {
        this.localErrors.transporter = this.t('checkout.validation.error.transporter')
      }

      if (
        this.useAddress === orderAddressOptions.shipping &&
        (
          this.customerData.sendto_name === '' ||
          this.customerData.sendto_surname === '' ||
          this.customerData.sendto_landphone === '' ||
          this.customerData.sendto_city === '' ||
          this.customerData.sendto_postal === '' ||
          this.customerData.sendto_address === '' ||
          this.customerData.sendto_country === '' ||
          this.customerData.sendto_county === ''
        )
      ) {
        this.localErrors.shipping = this.t('checkout.validation.error.shipping')
      }

      if (
        this.previewOrderData.invoiceType === 'invoice' &&
        (
          this.previewOrderData.company_afm === '' ||
          this.previewOrderData.company_doy === '' ||
          this.previewOrderData.company_name === '' ||
          this.previewOrderData.company_address === '' ||
          this.previewOrderData.profession === ''
        )
      ) {
        this.localErrors.invoice = this.t('checkout.validation.error.invoice')
      }

      if (this.previewOrderData.invoiceType !== 'invoice' && this.previewOrderData.invoiceType !== 'receipt') {
        this.localErrors.invoice = this.t('checkout.validation.error.invoice')
      }

      if (!this.giftsValidation()) {
        this.localErrors.gifts = 'giftsError'
      }

      if (this.smartPointValidationError) {
        this.localErrors.smartPoint = this.t('checkout.validation.error.smart_point')
      }

      if (this.payWayDeliveryComboDisallowed('paid_at_store', '2') || (this.previewOrderData.payWay === 'delivery' && this.useAddress === '2')) {
        this.localErrors.payWayDeliveryComboDisallowed = this.t('preview.order.invalid.pay_way-delivery.combo.error', {
          params: [{
            payWayName: this.getPayWayNameByKey(),
            deliveryName: this.getDeliveryMethodNameByKey()
          }]
        })
      }

      const requiredEls = this.$refs.checkoutForm.querySelectorAll('[required]')
      for (const requiredEl of requiredEls) {
        const field = lowerCase(requiredEl.dataset.field_name)
        if (requiredEl.getAttribute('name') === 'accept_terms') {
          if (!requiredEl.checked) {
            this.localErrors[requiredEl.getAttribute('name')] = this.t('form_validation_required', { params: [{ field }] })
          }
        }
        const isFieldInvalid = requiredEl.value.trim() !== ''
        if (isFieldInvalid) {
          continue
        }
        this.localErrors[requiredEl.getAttribute('name')] = this.t('form_validation_required', { params: [{ field }] })
      }

      this.$store.commit('setCheckoutLocalErrors', this.localErrors)
      if (!this.displayLocalErrors) {
        return true
      }

      this.openValidationErrorsModal()
      e.preventDefault()
    },
    isPayWayOptionAvailable (payWayClass) {
      switch (payWayClass) {
        case 'paid_at_store':
          if (!this.isCartTotalAbovePaidAtStoreMinCartTotalLimit) {
            return false
          }
          break
        case 'delivery':
          if (this.getIsSmartPointOnlyTransporter) {
            return false
          }
          break
        case 'klarna_payments':
          if (
            (!this.previewOrderData.storeId && !this.previewOrderData.transporterId) &&
            (
              (this.sameShipping && this.customerData.country === '') ||
              (!this.sameShipping && this.customerData.sendto_country === '')
            )
          ) {
            return false
          }
          break
      }
      return true
    },
    async onChangeTransporter () {
      const selectedTransporter = this.getSelectedTransporterObject
      if (selectedTransporter?.eshop_calculated_cost === "0") {
        await this.getExternalTransporterCost()
      }
      this.setPayWayAfterTransporterUpdate()
    },
    setPayWayAfterTransporterUpdate () {
      if (this.getIsSmartPointOnlyTransporter) {
        if ('delivery' === this.previewOrderData.payWay) {
          this.previewOrderData.payWay = this.previewOrderData.payWays.filter(payWay => 'delivery' !== payWay.key)[0].key
        }
      }
    },
    paywayRadioSelected() {
      this.setDeliveryBasedOnPayWay()

      if (this.previewOrderData.payWay === 'klarna_payments') {
        this.handleKlarnaPaymentsRadioSelected()
      }
    },
    setDeliveryBasedOnPayWay () {
      if (this.previewOrderData.payWay === 'paid_at_store') {
        if (this.isCourierAddress === '1') {
          this.isCourierAddress = '0'
          return
        }
      }

      if (this.previewOrderData.payWay === 'delivery') {
        if (this.isCourierAddress === '0') {
          this.isCourierAddress = '1'
        }
      }
    },
    handleKlarnaPaymentsRadioSelected() {
      if (this.klarnaPaymentSessionSessionId === '') {
        this.openPaymentSession()
      } else {
        this.updatePaymentSession()
      }
    },
    async setTransporterId (val) {
      await this.setPreviewOrderTransporterId(val)
      this.setPayWayAfterTransporterUpdate()
    },
    giftsValidation () {
      if (this.giftUserSelectionStatus.invalid) {
        const invalidChoiceBase = this.t(
          'action.submit.status.invalid',
          { namespace: 'giftSelection' }
        )
        const invalidChoiceReason = this.t(
          `action.submit.status.${this.giftUserSelectionStatus.statusKey}`,
          { namespace: 'giftSelection' }
        )
        this.$toasted.error(`${invalidChoiceBase} ${invalidChoiceReason}`, { duration: 2500 })
        this.jQuery('#GiftChoiceModal').modal('show')
        return false
      }
      this.jQuery('#GiftChoiceModal').modal('hide')
      return true
    },
    smartPointUncheck () {
      this.$store.dispatch('smartPointUncheck')
    },
    getPayWayNameByKey () {
      const payWayKey = this.previewOrderData.payWay
      return this.validPayWays.find(payWay => payWay.key === payWayKey).value
    },
    getDeliveryMethodNameByKey () {
      const deliveryMethodKey = this.useAddress
      switch (deliveryMethodKey) {
        case '0':
          return this.t('preview.order.send.by.courier')
        case '1':
          return this.t('preview.order.send.by.courier')
        case '2':
          return this.t('preview.order.pickup.at.store')
      }
    },
    payWayDeliveryComboDisallowed (payWay, useAddress) {
      return this.previewOrderData.payWay === payWay && this.useAddress !== useAddress
    },
    openValidationErrorsModal () {
      this.$nextTick(() => {
        if (!this.displayGiftError) {
          window.scrollTo({ top: 0, behavior: 'smooth' })
          this.$refs.CheckoutErrorsModal.openModal()
          return
        }
        this.$refs.AdvGiftChoiceModalV2.$refs.AdvGiftChoiceGenericModal.openModal()
      })
    },
    sanitizePhoneNumber () {
      this.customerData.landphone = phoneNumberSanitizer(this.customerData.landphone)
      this.customerData.mobilephone = phoneNumberSanitizer(this.customerData.mobilephone)
    },
    async handleCartData (invoice, useAddress, billingCountry, shippingCountry) {
      try {
        const data = await api.cartData({
          invoice: invoice,
          useAddress: useAddress,
          billingCountry: billingCountry,
          shippingCountry: shippingCountry
        })
        const cartContents = data.cartContents
        const liveData = data.liveData
        const giftContents = data.giftContents
        await Promise.all([
          this.setCartProducts(cartContents),
          this.setCartLiveData(liveData),
          this.setLiveProducts(liveData),
          this.setGiftContents(giftContents)
        ])
      } catch (error) {
        console.error(error)
      }
    },
    openPaymentSession() {
      if (typeof this.customerData.country === "string" && this.customerData.country.length === 0) {
        alert(this.t('klarnaWidget.select.country'))
        return
      }

      this.openPaymentSessionAction({
        intent: 'buy',
        purchase_country: this.customerData.country,
        purchase_currency: 'EUR',
        locale: 'el-GR',
        order_amount: this.orderTotal,
        transportationCost: this.transportationCost,
        couponDiscount: this.couponDiscount,
        giftPackagingCost: this.giftPackagingCost,
        pointsDiscount: this.redeemPoints ? this.previewOrderData.loyalty.customerCash : 0
      })
    },
    async updatePaymentSession() {
      const result = await api.doUpdatePaymentSession({
        transportationCost: this.transportationCost,
        couponDiscount: this.couponDiscount,
        giftPackagingCost: this.giftPackagingCost,
        pointsDiscount: this.redeemPoints ? this.previewOrderData.loyalty.customerCash : 0,
        session_id: this.klarnaPaymentSessionSessionId,
        order_amount: this.orderTotal
      })

      if (result.success === true) {
        this.$refs.klarnaWidgetRef.explicitKlarnaPaymentsLoad()
      }
    },
    setKlarnaPaymentAuthorization(data) {
      if ('error' in data) {
        return
      }

      this.$store.commit('klarnaPaymentAuthorizationMutation', data)

      if (data.approved === true && data.show_form === true && this.termsChecked) {
        this.$nextTick(() => {
          this.$refs.submitButton.click()
        })
      }
    }
  }
}
